







import {Component, Vue} from 'vue-property-decorator';

import PlayerPanel from "@service/components/player-panel/PlayerPanel.vue";
import { Meeting } from '@api/models/meetings/Meeting';
import { EventInterface } from '@share/program/types/EventInterface';
import { RouteNamesEnum } from '@service/router/RouteNamesEnum';
import { isRouteForBackground } from "@service/router/helpers/commonRoutesHelper";

@Component({
    components: { PlayerPanel }
})
export default class HeaderPlayer extends Vue {

    goToVideo() {
        const routeName = this.$store.state.miniPlayer.returnRouteName as RouteNamesEnum;

        if(isRouteForBackground(routeName)) {
            this.$router.push({
                name: routeName,
                params: {
                    backend: this.$route.params.backend,
                    eventId: this.$route.params.eventId,
                    id: this.$store.state.miniPlayer.object.id
                }
            })
        }
        else {
            this.$router.push({
                name: routeName,
                params: this.$route.params
            })
        }
    }

    get title(): string {
        if (this.object instanceof Meeting) {
            return this.$t('common.meeting').toString();
        }
        return this.object.title || '';
    }

    get object() {
        return this.$store.state.miniPlayer.object;
    }
}
